import Leaderboard from './leaderboard.component';

export default Leaderboard;
